import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { MenteeGroupData } from '../../providers/mentee-group-data';
import { GlobalVariable } from '../../global';
import { HomePage } from '../home/home';
@IonicPage()
@Component({
  selector: 'page-mentee-group-form',
  templateUrl: 'mentee-group-form.html',
})
export class MenteeGroupFormPage {
  groupForm: FormGroup
  organisationId: any
  usertype: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private storage: Storage,
    private menteeGroupData: MenteeGroupData, private toastCtrl: ToastController, private alertCtrl: AlertController) {
    this.storage.get('organisationId').then((value) => {
      this.organisationId = value;
    });
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
    this.groupForm = this.formBuilder.group({
      groupname: ['', Validators.required],
      organisationid: ['']
    });
  }

  ionViewDidLoad() {
  }

  onSubmit(value) {
    this.groupForm.controls['organisationid'].setValue(this.organisationId)

    this.menteeGroupData.createMenteeGroup(this.groupForm.value).subscribe(
      res => {
        this.presentToast('Mentee Group Created Successfully')
        this.groupForm.reset()
      },
      err => {
        this.presentAlert('Error', err.error.data.groupname.msg)
      }
    )

  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/mentee-group-form/mentee-group-form.ts